export enum RoundingType {
  NoRounding = "NoRounding",
  MathRounding = "MathRounding",
  RoundingUp = "RoundingUp",
  RoundingDown = "RoundingDown"
}
